// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__G2KFw","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2xLXG"};